import React, { useContext, useMemo } from 'react';
import {
  DetailContext,
  Table,
  useEventCallback,
  useUpdateEffect,
  DetailMode,
  TableHandle,
} from '@eas/common-web';
import { ExportTags } from '../../../../enums/export-tags';
import { User, RoleInstance } from '../../../../models';
import { useEmpoweredRoles } from './role-empowered-hook';
import { ToolbarExportButton } from '../../../../components/evidence/history-evidence/overrides/toolbar-export-button';

export function EmpoweredRoles({
  profile,
  useStyles,
  showReportButton = true,
}: {
  profile: User;
  useStyles?: () => TableHandle<RoleInstance>['classes'];
  showReportButton?: boolean;
}) {
  const detailCtx = useContext(DetailContext);
  const { source, columns } = useEmpoweredRoles(profile);

  const sorts = useMemo(
    () => [
      {
        field: 'active',
        datakey: 'active',
        order: 'DESC' as const,
        type: 'FIELD' as const,
      },
    ],
    []
  );

  const exportProvideData = useEventCallback(() => ({
    userId: profile.id,
  }));

  const include = useMemo(() => ['DEACTIVATED'], []);

  useUpdateEffect(() => {
    if (detailCtx?.mode === DetailMode.VIEW) {
      source.reset();
      source.loadMore();
    }
  }, [profile.id]);

  return (
    <Table
      version={7}
      tableId="ROLES_EMPOWERED"
      tableName="Role nabyté zmocněním"
      columns={columns}
      source={source}
      height={300}
      showBulkActionButton={false}
      showSelectBox={false}
      showSearchbar={false}
      showReportButton={false}
      showResetSortsButton={true}
      reportTag={ExportTags.USER_ROLES_EMPOWERED}
      exportProvideData={exportProvideData}
      defaultSorts={sorts}
      include={include}
      useStyles={useStyles}
      toolbarProps={{
        after: detailCtx?.mode === DetailMode.VIEW && showReportButton && (
          <ToolbarExportButton />
        ),
      }}
    />
  );
}
